import logo from "./logo.svg";
import Homepage from "./Homepage";

function App() {
  return (
    <>
      <Homepage />
    </>
  );
}

export default App;
